document.addEventListener("click", (event) => {
  const addButton = event.target.closest("[data-add-invoice-line]");
  if (addButton) {
    const template = document.querySelector("[data-invoice-line-template]");
    const body = document.querySelector("[data-invoice-lines]");
    if (!template || !body) return;

    const key = `${Date.now()}${Math.floor(Math.random() * 1000)}`;
    body.insertAdjacentHTML("beforeend", template.innerHTML.replace(/NEW_RECORD/g, key));
    filterInvoiceItems();
    return;
  }

  const removeButton = event.target.closest("[data-remove-invoice-line]");
  if (!removeButton) return;

  const row = removeButton.closest("tr");
  const destroyField = row.querySelector("[data-destroy-field]");
  if (destroyField && destroyField.value !== "") {
    destroyField.value = "1";
    row.hidden = true;
  } else {
    row.remove();
  }
});

const filterInvoiceItems = () => {
  const organisationId = document.querySelector("#administration_invoice_organisation_id")?.value;

  document.querySelectorAll("[data-invoice-item]").forEach((select) => {
    Array.from(select.options).forEach((option) => {
      if (!option.value) return;
      const relevant = Boolean(organisationId) && option.dataset.organisationId === organisationId;
      option.hidden = !relevant;
      option.disabled = !relevant;
    });

    if (select.selectedOptions[0]?.disabled) select.value = "";
  });
};

document.addEventListener("change", (event) => {
  if (event.target.matches("#administration_invoice_organisation_id")) {
    filterInvoiceItems();
    return;
  }

  if (!event.target.matches("[data-invoice-item]")) return;
  if (!event.target.value.includes("Administration::Subscription")) return;

  const revenueSelect = event.target.closest("tr").querySelector("[data-revenue-type]");
  if (revenueSelect) revenueSelect.value = "technologie";
});

document.addEventListener("DOMContentLoaded", filterInvoiceItems);
